/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_03_TitleInputs */

const en_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstract Fluid`)
};

const ar_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيولة تجريدية`)
};

const bn_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাবস্ট্রাক্ট ফ্লুইড`)
};

const de_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrakte Flüssigkeit`)
};

const es_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluido abstracto`)
};

const fr_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluide abstrait`)
};

const pt_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluido abstrato`)
};

const zh_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽象流体`)
};

const tr_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyut Akışkan`)
};

const ru_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абстрактная жидкость`)
};

const pl_elastic_gallery_item_03_title = /** @type {(inputs: Elastic_Gallery_Item_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstrakcyjny płyn`)
};

/**
* | output |
* | --- |
* | "Abstract Fluid" |
*
* @param {Elastic_Gallery_Item_03_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_03_title = /** @type {((inputs?: Elastic_Gallery_Item_03_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_03_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_03_title(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_03_title(inputs)
	if (locale === "de") return de_elastic_gallery_item_03_title(inputs)
	if (locale === "es") return es_elastic_gallery_item_03_title(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_03_title(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_03_title(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_03_title(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_03_title(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_03_title(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_03_title(inputs)
	return en_elastic_gallery_item_03_title(inputs)
});